// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wid-heig[data-v-032fb28f] {\n  width: 100%;\n  height: 70vh;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
